import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@services/translation/translation.service';

@Pipe({
  name: 'translate'
})
export class TranslationPipe implements PipeTransform {
  constructor(private translation_svc: TranslationService) {}

  transform(key: string, args?: string | string[] | undefined): string {
    return this.translation_svc.translate(key, args);
  }
}
